/**
 * Return the default booking duration to be used in the data pickers and search form
 * Tries to select a value out of the launch darkly feature flag, if not available, returns 2 which is our normal default
 * @returns {number|*}
 */
const getDefaultBookingDurationHours = () => {
  try {
    // eslint-disable-next-line no-underscore-dangle
    return window.__data.launchDarkly.entities['default-booking-duraton'].value;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
    return 2;
  }
};

export default getDefaultBookingDurationHours;
